/**
 * Category Repository Factory
 *
 * 환경 변수(USE_MOCK_DATA)에 따라 Mock 또는 GoogleSheets Repository를 반환합니다.
 */

import { env } from '@/core/config/env'
import { logger } from '@/core/logger'
import { MockCategoryRepository } from './MockCategoryRepository'
import { GoogleSheetsCategoryRepository } from './GoogleSheetsCategoryRepository'
import type { CategoryRepository } from './CategoryRepository'

/**
 * Category Repository 인스턴스 생성
 *
 * env.USE_MOCK_DATA 값에 따라 자동으로 선택됩니다.
 *
 * @returns CategoryRepository 구현체
 */
export function createCategoryRepository(): CategoryRepository {
  if (env.USE_MOCK_DATA) {
    logger.info('🔧 Mock Category Repository 사용')
    return new MockCategoryRepository()
  }

  logger.info('🔗 Google Sheets Category Repository 사용')
  return new GoogleSheetsCategoryRepository()
}

/**
 * 전역 Category Repository 인스턴스
 *
 * 애플리케이션 전체에서 동일한 인스턴스를 사용합니다.
 */
export const categoryRepository = createCategoryRepository()

// Re-export 타입
export type { CategoryRepository } from './CategoryRepository'
export type { Category } from '../types/Category'
